// Constants
const URLS = {
    PROJECT: '/projects',
};

const SELECTOR = {
    COPY_ACTION_CHECKBOXES: 'data-copy-action-target',
    COPY_ACTION_VISUAL_TOGGLER: 'copy-board-option__visual-toggler',
    COPY_ACTION_FOR: 'data-copy-action-for',
    COPY_FORM_PLACEMENT: 'data-copy-board-form-placement',

    DETERMINED_PROJECT_ID: 'data-copy-board-determined-project-id',
    DETERMINED_BOARD_ID: 'data-copy-board-determined-board-id',
    MAIN_WRAPPER: 'copy-board-wrapper',
    INPUT_WRAPPER: 'copy-board-input-wrapper',

    TARGET_PROJECT_SELECT: 'copy-target-project-select',
    TARGET_PROJECT_LIST: 'copy-target-project-list',
    TARGET_PROJECT_INPUT: 'copy-target-project-input',

    PROJECTS_SELECT: 'copy-projects-select',
    PROJECTS_LIST: 'copy-projects-list',
    PROJECTS_INPUT: 'copy-projects-input',

    BOARDS_SELECT: 'copy-boards-select',
    BOARDS_LIST: 'copy-boards-list',
    BOARDS_INPUT: 'copy-boards-input',

    ITEM_IN_LIST: 'board__project-item',
    ITEM_LIST_OVERLAY: 'board__project-overlay',
    ITEM_SELECT: 'board__project-select',
    ITEM_INPUT: 'board__project-input',

    FORM_SUBMIT: 'copy-board-submit',
}

const FORM_PLACEMENT = {
    APP_DASHBOARD: 'dashboard',
    APP_BOARDS: 'boards',
    APP_PROJECTS: 'projects',
    THEME_COLLECTION_TEMPLATE: 'collection',
    THEME_PRODUCT_TEMPLATE: 'product',
}

const LABELS = {
    SELECT_BOARD: 'Select Board',
    PROJECTS_EMPTY: 'No Projects found',
    PROJECTS_WITHOUT_BOARDS: 'Your Projects have no boards to copy',
}

let copyActionButtons;
let formPlacement;
let determinedProjectId;
let determinedBoardId;
let mainWrapper;
let inputWrapper;
let targetProjectSelect;
let targetProjectList;
let targetProjectInput;
let projectSelect;
let projectList;
let projectInput;
let boardWrapper;
let boardSelect;
let boardList;
let boardInput;
let formSubmit;


// EVENT HANDLERS
const onCopyActionButtonClick = (event) => {
    const target = event.currentTarget.getAttribute(SELECTOR.COPY_ACTION_CHECKBOXES);
    const targetToShow = document.querySelector(`[${SELECTOR.COPY_ACTION_FOR}="${target}"]`);
    if (!targetToShow) return;

    copyActionButtons.forEach(button => {
        button.classList.remove('active');

        const buttonTarget = button.getAttribute(SELECTOR.COPY_ACTION_CHECKBOXES);
        const targetWrapper = document.querySelector(`[${SELECTOR.COPY_ACTION_FOR}="${buttonTarget}"]`);
        if (targetWrapper) {
            targetWrapper.style.display = 'none';
        }
    });

    event.currentTarget.classList.add('active');
    targetToShow.style.display = 'block';
};

const onInputWrapperClick = (event) => {
    if (event.currentTarget.classList.contains('disabled')) return;

    const parentWrapper = event.target.closest(`.${SELECTOR.MAIN_WRAPPER}`);
    if (!parentWrapper) return;

    document.querySelectorAll(`.${SELECTOR.ITEM_LIST_OVERLAY}`).forEach(overlay => {
        if (overlay !== parentWrapper.querySelector(`.${SELECTOR.ITEM_LIST_OVERLAY}`)) {
            overlay.style.display = 'none';
        }
    });

    const targetOverlay = parentWrapper.querySelector(`.${SELECTOR.ITEM_LIST_OVERLAY}`);
    if (targetOverlay) {
        targetOverlay.style.display = (targetOverlay.style.display === 'none' || !targetOverlay.style.display) ? 'block' : 'none';
    }
};

const onListItemSelect = (event) => {
    event.preventDefault();

    const parentWrapper = event.target.closest(`.${SELECTOR.MAIN_WRAPPER}`);
    if (!parentWrapper) return;

    const targetListOverlay = parentWrapper.querySelector(`.${SELECTOR.ITEM_LIST_OVERLAY}`);
    if (!targetListOverlay) return;

    targetListOverlay
        .querySelectorAll(`.${SELECTOR.ITEM_IN_LIST}`)
        .forEach((item) => {
            item.setAttribute('data-active', item === event.target);
        });

    const targetSelect = parentWrapper.querySelector(`.${SELECTOR.ITEM_SELECT}`);
    const targetInput = parentWrapper.querySelector(`.${SELECTOR.ITEM_INPUT}`);
    if (!targetSelect || !targetInput){
        console.error('Target select or input not found', { targetSelect, targetInput });
        return;
    }

    if (targetListOverlay.id === SELECTOR.PROJECTS_LIST){
        boardInput.closest(`.${SELECTOR.INPUT_WRAPPER}`).classList.remove('disabled');
    }

    const { id, title } = event.target.dataset;
    const option = targetSelect.options[0];

    option.value = id;
    option.textContent = title;
    targetSelect.value = id;
    targetInput.value = title;

    targetSelect.dispatchEvent(new Event('change'));
    targetListOverlay.style.display = 'none';
    updateFormSubmitState();
};

const onProjectSelectChange = (event) => {
    const projectId = event.target.value;
    if (!projectId) return;

    const boardItems = boardList.querySelectorAll(`.${SELECTOR.ITEM_IN_LIST}`);
    boardItems.forEach(item => {
        if (item.getAttribute('data-project-id') === projectId) {
            item.style.display = 'block';
        } else {
            item.style.display = 'none';
        }
    });

    _resetBoardSelectState();
    boardWrapper.style.display = 'block';
    updateFormSubmitState();
};

function _resetBoardSelectState(){
    boardSelect.value = '';
    boardInput.value = LABELS.SELECT_BOARD;
    updateFormSubmitState();
}

const fetchData = (url, options = {}) => {
    const apiUrl = window.DHSettings.apiUrl;
    const apiKey = window.DHSettings.apiToken;
    if (!apiUrl || !apiKey) {
        console.error('API url or key is missing', { apiUrl, apiKey });
        return false;
    }

    const { headers = {} } = options;
    const fetchPromise = fetch(`${apiUrl}${url}`, {
        ...options,
        headers: {
            'api-key': apiKey,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...headers,
        },
    }).then((response) => response.json());

    fetchPromise
        .then((response) => {
            if (response){
                projects = response.data;
                try {
                    populateProjectsAndBoardsLists(projects);
                } catch (error) {
                    console.error('Failed to render projects & boards', { error });
                }
            }
        })
        .catch((error) => {
            console.error('Failed to fetch data', { error });
        })
        .finally(() => {
            console.log('Fetch attempt completed');
        });
};

const populateProjectsAndBoardsLists = (projects) => {
    const targetProjectSelectList = document.createDocumentFragment();
    const projectSelectList = document.createDocumentFragment();
    const boardSelectList = document.createDocumentFragment();

    if (!projects) return;

    if (projects.length === 0) {
        const emptyMsg = document.createElement('span');
        emptyMsg.textContent = LABELS.PROJECTS_EMPTY;
        targetProjectList.innerHTML = '';
        targetProjectList.appendChild(emptyMsg);
        return;
    }

    projects.forEach((project) => {
        const boards = project.attributes.boards || [];

        const targetProjectItem = _createListItemButton(project.id, project);
        targetProjectSelectList.appendChild(targetProjectItem);

        // skip projects without boards since there's nothing to copy
        if (!boards.length) {
            return;
        }

        const projectItem = _createListItemButton(project.id, project);
        projectSelectList.appendChild(projectItem);

        boards.forEach((board) => {
            const boardItem = _createListItemButton(project.id, board, true);
            boardSelectList.appendChild(boardItem);
        });
    });

    if (projectSelectList.childNodes.length === 0) {
        const emptyMsg = document.createElement('span');
        emptyMsg.textContent = LABELS.PROJECTS_WITHOUT_BOARDS;
        projectList.appendChild(emptyMsg);
        return;
    }

    targetProjectList.innerHTML = '';
    targetProjectList.appendChild(targetProjectSelectList);

    projectList.innerHTML = '';
    projectList.appendChild(projectSelectList);

    boardList.innerHTML = '';
    boardList.appendChild(boardSelectList);

    updateFormDeterminedData();
    updateFormSubmitState();
};

const _createListItemButton = (projectId, object, isBoardItem = false) => {
    const button = document.createElement('button');

    button.textContent = isBoardItem ? object.name : `${object.attributes.name} (${object.attributes.market.country_code})`;
    button.classList.add(SELECTOR.ITEM_IN_LIST);
    button.setAttribute('type', 'button');
    button.setAttribute('data-id', object.id);
    button.setAttribute('data-project-id', projectId);
    button.setAttribute('data-title', button.textContent);
    button.setAttribute('data-active', false);
    button.addEventListener('click', onListItemSelect);

    return button;
};

/* GLOBAL STUFFS */
function resetCopyBoardModal() {
    document.querySelectorAll(`[${SELECTOR.COPY_ACTION_CHECKBOXES}]`).forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll(`[${SELECTOR.COPY_ACTION_FOR}]`).forEach(el => el.style.display = 'none');

    const firstBtn = document.querySelector(`[${SELECTOR.COPY_ACTION_CHECKBOXES}]`);
    if (firstBtn) {
        firstBtn.classList.add('active');
        const target = firstBtn.getAttribute(SELECTOR.COPY_ACTION_CHECKBOXES);
        const targetFor = document.querySelector(`[${SELECTOR.COPY_ACTION_FOR}="${target}"]`);
        if (targetFor) targetFor.style.display = 'block';
    }

    if (projectInput) {
        projectInput.value = '';
    }
    if (projectSelect) {
        projectSelect.value = '';
    }
    if (projectList) {
        projectList.querySelectorAll(`.${SELECTOR.ITEM_IN_LIST}[data-active="true"]`).forEach(item => {
            item.setAttribute('data-active', false);
        });
    }

    if (boardInput) {
        boardInput.value = '';
        const wrapper = boardInput.closest(`.${SELECTOR.INPUT_WRAPPER}`);
        if (wrapper) wrapper.classList.add('disabled');
    }
    if (boardSelect) {
        boardSelect.value = '';
    }
    if (boardList) {
        boardList.querySelectorAll(`.${SELECTOR.ITEM_IN_LIST}[data-active="true"]`).forEach(item => {
            item.setAttribute('data-active', false);
        });
    }

    if (formSubmit) {
        formSubmit.disabled = true;
    }
}

function updateCopyBoardListUsingResponse(response){
    if (!response || !response.data) return;

    const newBoard = response.data;
    const projectId = newBoard.relationships.project.data.id;
    const newBoardItem = _createListItemButton(projectId, newBoard, true);
    boardList.appendChild(newBoardItem);
}

function updateCopyTargetProjectListUsingResponse(response){
    if (!response || !response.data) return;

    const newProject = response.data;
    const newProjectTitle = `${newProject.attributes.name} (${newProject.attributes.market.country_code})`;

    const targetProjectItem = _createListItemButton(newProject.id, newProject);
    targetProjectList.appendChild(targetProjectItem);

    const option = targetProjectSelect.options[0];
    option.value = newProject.id;
    option.textContent = newProjectTitle;
    targetProjectSelect.value = newProject.id;
    targetProjectInput.value = newProjectTitle;

    targetProjectSelect.dispatchEvent(new Event('change'));
    updateFormSubmitState();
}

/* HELPERS */
function hasValidSelection(selectEl) {
    if (!selectEl) return false;
    if (selectEl.tagName === 'SELECT') {
        return selectEl.value && selectEl.value !== '';
    }
    return selectEl.value && selectEl.value !== '';
}

function updateFormDeterminedData(){
    const currentDeterminedProjectId = determinedProjectId ? determinedProjectId.getAttribute(SELECTOR.DETERMINED_PROJECT_ID) : null;
    const currentDeterminedBoardId = determinedBoardId ? determinedBoardId.getAttribute(SELECTOR.DETERMINED_BOARD_ID) : null;

    if (formPlacement === FORM_PLACEMENT.APP_BOARDS) {
        if (!currentDeterminedProjectId || !currentDeterminedBoardId) return;

        const projectToSelect = projectList.querySelector(`[data-id="${currentDeterminedProjectId}"]`);
        const boardToSelect = boardList.querySelector(`[data-id="${currentDeterminedBoardId}"]`);

        if (projectToSelect && boardToSelect) {
            projectToSelect.click();
            boardToSelect.click();
        }
    }
    else{
        if (currentDeterminedProjectId) {
            const projectToSelect = targetProjectList.querySelector(`[data-id="${currentDeterminedProjectId}"]`);
            if (projectToSelect) {
                projectToSelect.click();
            }
        }
    }
}

function updateFormSubmitState() {
    if (!formSubmit) return;
    const allValid = hasValidSelection(targetProjectSelect) && hasValidSelection(projectSelect) && hasValidSelection(boardSelect);
    formSubmit.disabled = !allValid;
}


/* INITIALIZATION */
const initElements = () => {
    copyActionButtons = document.querySelectorAll(`[${SELECTOR.COPY_ACTION_CHECKBOXES}]`);
    formPlacement = document.querySelector(`[${SELECTOR.COPY_FORM_PLACEMENT}]`)?.getAttribute(SELECTOR.COPY_FORM_PLACEMENT);
    determinedProjectId = document.querySelector(`[${SELECTOR.DETERMINED_PROJECT_ID}]`);
    determinedBoardId = document.querySelector(`[${SELECTOR.DETERMINED_BOARD_ID}]`);
    inputWrapper = document.querySelectorAll(`.${SELECTOR.INPUT_WRAPPER}`);

    targetProjectSelect = document.querySelector(`#${SELECTOR.TARGET_PROJECT_SELECT}`);
    targetProjectList = document.querySelector(`#${SELECTOR.TARGET_PROJECT_LIST}`);
    targetProjectInput = document.querySelector(`#${SELECTOR.TARGET_PROJECT_INPUT}`);

    projectSelect = document.querySelector(`#${SELECTOR.PROJECTS_SELECT}`);
    projectList = document.querySelector(`#${SELECTOR.PROJECTS_LIST}`);
    projectInput = document.querySelector(`#${SELECTOR.PROJECTS_INPUT}`);

    boardWrapper = document.querySelector(`#${SELECTOR.BOARDS_SELECT}`).closest(`.${SELECTOR.MAIN_WRAPPER}`);
    boardSelect = document.querySelector(`#${SELECTOR.BOARDS_SELECT}`);
    boardList = document.querySelector(`#${SELECTOR.BOARDS_LIST}`);
    boardInput = document.querySelector(`#${SELECTOR.BOARDS_INPUT}`);

    formSubmit = document.querySelector(`#${SELECTOR.FORM_SUBMIT}`);
    if (formSubmit) {
        formSubmit.disabled = true;
    }
};

const initEventListeners = () => {
    copyActionButtons.forEach(checkbox => {
        checkbox.addEventListener('click', onCopyActionButtonClick);
    });
    inputWrapper.forEach(wrapper => {
        wrapper.addEventListener('click', onInputWrapperClick);
    });

    projectSelect.addEventListener('change', onProjectSelectChange);

    document.addEventListener('click', (event) => {
        if (!event.target.closest(`.${SELECTOR.ITEM_LIST_OVERLAY}`) && !event.target.closest(`.${SELECTOR.INPUT_WRAPPER}`)) {
            document.querySelectorAll(`.${SELECTOR.ITEM_LIST_OVERLAY}`).forEach(overlay => {
                overlay.style.display = (overlay.style.display === 'block') ? 'none' : overlay.style.display;
            });
        }
    });

    // Listen for changes on all relevant selects/inputs to update submit button
    if (targetProjectSelect) {
        targetProjectSelect.addEventListener('change', updateFormSubmitState);
    }
    if (boardSelect) {
        boardSelect.addEventListener('change', updateFormSubmitState);
    }
};

const initCustomEvents = () => {
    window.resetCopyBoardModal = resetCopyBoardModal;
    window.updateCopyBoardListUsingResponse = updateCopyBoardListUsingResponse;
    window.updateCopyTargetProjectListUsingResponse = updateCopyTargetProjectListUsingResponse;
};


(function() {
    initElements();
    initEventListeners();
    initCustomEvents();
    fetchData(URLS.PROJECT);
    updateFormSubmitState();
})();
